export default "__VITE_ASSET__CdDAUch7__"